module.exports = __webpack_public_path__ + "static/media/MERS-GSE56192.60a4a530.csv";